<template>
  <div
    class="-mx-2 my-[-0.3125rem] flex items-center px-2 py-[0.3125rem] normal-case"
  >
    <input
      type="checkbox"
      :aria-label="ariaLabel"
      :checked="isFullySelected"
      :indeterminate="isIndeterminate"
      class="rounded border border-gray-300 bg-white text-blue-500 transition-colors focus:ring-0 focus:ring-offset-0 focus-visible:outline focus-visible:outline-blue-500 dark:border-border dark:bg-sidebar dark:checked:border-muted-foreground dark:checked:bg-muted-foreground"
      @input="onInputChange"
    />
  </div>
</template>

<script setup lang="ts">
import type { Table, TableMeta } from "@tanstack/vue-table";
import { computed } from "vue";

import type { GenericModel } from "@/types/model";

import { useSelectionCheckbox } from "../selection-helpers";

const props = defineProps<{
  table: Table<GenericModel>;
  selection: NonNullable<TableMeta<GenericModel>["selection"]>;
  label: string;
}>();

const { isFullySelected, isIndeterminate } = useSelectionCheckbox({
  state: props.selection.state,
  items: () => props.table.options.data,
  canSelect: props.selection.canSelect,
});

const ariaLabel = computed(() => {
  return isFullySelected.value || isIndeterminate.value
    ? `Clear selection`
    : props.label;
});

const onInputChange = (ev: Event) => {
  const input = ev.currentTarget as HTMLInputElement;
  isFullySelected.value = input.checked;
  // The composable rejects "select all" when the visible set is empty;
  // keep the checkbox in sync with the unchanged state.
  input.checked = isFullySelected.value;
};
</script>
